
import React, {FC} from 'react';
import {useInterviewer} from 'components/Assistant/_Interviewer/useInterviewer';
import {Chat} from 'components/ContentPagesComponents/Assistant/Shared/Chat';
import {Layout} from 'components/ContentPagesComponents/Assistant/Shared/Layout';
import {LeftImage} from 'components/ContentPagesComponents/Assistant/Shared/LeftImage';
import {BG} from 'constants/index';

import LearnIcon from './svgs/learn.inline.svg';
import {track} from './utils';

type InterviewerProps = {
	bg?: BG
	track?: string
	title: string
	subject: string
}

export const Interviewer: FC<InterviewerProps> = ({
	bg = BG.transparent,
	track: trKey,
	title,
	subject = '',
}) => {
	const assistant = useInterviewer(subject);
	const bgURL = 'https://static.bodyspec.com/at/c7/ae/c7ae2741d7091ab2';
	return (
		<Layout bg={bg} title={title}>
			<LeftImage imageSrc={bgURL}>
				<LearnIcon />
				<h1>AI-powered body composition analysis</h1>
				<h2>Get targeted results based on your goals</h2>
			</LeftImage>
			<Chat
				assistant={assistant}
				track={track(trKey || subject)}
			/>
		</Layout>
	);
};
